import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const sinkSlice = createSlice({
  name: "sinks",
  initialState,
  reducers: {
    addSink: (state, action) => {
      return [...state, action.payload];
    },
    removeSink: (state, action) => {
      return action.payload;
    },
    updateSinkVariantValue: (state, action) => {
      const { checked, itemIndex, variantId } = action.payload;
      state[itemIndex]["variant"][variantId]["value"] = checked;
    },
    /** Sets the last pos of the sink */
    updateSinkPos: (state, action) => {
      const { x, y, offsetX, offsetY, rotation, index } = action.payload;
      state[index].x = x;
      state[index].y = y;
      state[index].offsetX = offsetX;
      state[index].offsetY = offsetY;
      state[index].rotation = rotation;
    },
    updateSinkGap: (state, action) => {
      const { value, index } = action.payload;
      state[index].sinkGap = value;
    },
    addMounting: (state, action) => {
      const { value, index } = action.payload;
      state[index].mounting = value;
    },
  },
});

/** Actions */
export const {
  addSink,
  removeSink,
  updateSinkVariantValue,
  updateSinkPos,
  updateSinkGap,
  addMounting,
} = sinkSlice.actions;

/** Selectors */
export const getSinks = (store) => store.sinks;
export const getMounting = (store) => store.sinks.mounting;
